/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_activity_ui_detailfeedback1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상세 피드백`)
};

const en_activity_ui_detailfeedback1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Feedback`)
};

const ja_activity_ui_detailfeedback1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細フィードバック`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const activity_ui_detailfeedback1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.activity_ui_detailfeedback1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("activity_ui_detailfeedback1", locale)
	if (locale === "ko") return ko_activity_ui_detailfeedback1(inputs)
	if (locale === "en") return en_activity_ui_detailfeedback1(inputs)
	return ja_activity_ui_detailfeedback1(inputs)
};
export { activity_ui_detailfeedback1 as "activity_ui_detailFeedback" }